import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidePanelModule } from '../../shared/side-panel/side-panel.module';
import { SideNavComponent } from './side-nav.component';


@NgModule({
  imports: [
    CommonModule,
    SidePanelModule
  ],
  exports: [
    SideNavComponent
  ],
  declarations: [
    SideNavComponent
  ],

  providers: []
})
export class SideNavModule { }
